define('ensureArray/ensureArray',[], function() {
	var UNDEF='undefined';
	return function( thing ) {
		if (Array.isArray(thing)) {
			return thing;
		} else if (typeof thing === UNDEF) {
			return [];
		} else {
			return [thing];
		}
	}
});
